<template>
  <div class="jr-mx-15 jr-text-left">
    <p class="jr-text-sm jr-font-medium">選択範囲にある道路利用者の行動をヒートマップで表示しています。</p>
  </div>
</template>
